import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';

import { HelperService } from './../../../../services/helper.service';
import { AddressService } from './../../../../rest/api/address.service';
import { MemberService } from './../../../../rest/api/member.service';
import { PaymentService } from './../../../../services/payment/payment.service';
import { AuthService } from './../../../../services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';

import {Buffer} from 'buffer';

@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.scss']
})
export class BillingComponent implements OnInit {
  accessToken: any;
  langShortCode: any;
  addressData: any;
  addressId: any;
  billingId: any;
  serviceId: any;
  pageLoader = true;
  spaceHosted: any;

  totalCount: number;
  itemsPerPage = 10;
  currentPage = 1;

  invoiceData: any;
  invoiceLoader = true;

  cardData: any;
  cardLoader = true;

  subscriptionData: any;
  currentSubscription: any;
  currentPlansData: any;
  cameraSubscription: any;
  subscriptionChart: any;
  subscriptionLoader = true;

  invoiceDownload = false;
  invoiceDownloadError: any;
  selectedInvoice: any;

  shopCameraClicked = false;

  billingAccess: any;
  invoiceAccess: any;
  companyRole: any;

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private authService: AuthService,
    private addressService: AddressService,
    public helperService: HelperService,
    public memberService: MemberService,
    public paymentService: PaymentService
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
    this.langShortCode = localStorage.getItem('language') ? localStorage.getItem('language') : undefined;
    this.companyRole = this.authService.getCompanyRoles();
    if (this.companyRole && this.companyRole === 'owner') {
      this.billingAccess = true;
      this.invoiceAccess = true;
    } else if (this.companyRole && this.companyRole === 'admin') {
      this.billingAccess = this.authService.getBillingAccess();
      this.invoiceAccess = this.authService.getInvoiceAccess();
    } else {
      this.billingAccess = false;
      this.invoiceAccess = false;
    }
   }

  ngOnInit() {
    this.getCurrentSubscription();
    if (this.invoiceAccess) {
      this.getInvoices(1, this.itemsPerPage);
    }
    if (this.billingAccess) {
      this.getPaymentCard();
      this.getAddresses();
    }
  }

  getAddresses() {
    this.addressService.getAddressList(this.accessToken).subscribe((response: any) => {
      this.pageLoader = false;
      this.addressData = response && response.data ? response.data : [];
    }, err => {
      this.addressData = [];
      this.pageLoader = false;
    });
  }

  getAddress(data) {
    if (data && data.type === 'billing') {
      return 'Billing Address';
    } else {
      return 'Service Address';
    }
  }

  getInvoices(page, limit) {
    this.memberService.getInvoices({
      Authorization: this.accessToken,
      page: page,
      paginate: limit
    }).subscribe((response: any) => {
      this.totalCount = response && response.meta && response.meta.pagination && response.meta.pagination.total ? response.meta.pagination.total : 0;
      this.invoiceData = response && response.data ? response.data : [];
      this.invoiceLoader = false;
    }, err => {
      this.invoiceData = [];
      this.invoiceLoader = false;
    });
  }

  pageChanged(event) {
    this.invoiceLoader = true;
    this.currentPage = event;
    this.getInvoices(event, this.itemsPerPage);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  getPaymentCard() {
    this.memberService.getPaymentCard(this.accessToken).subscribe((response: any) => {
      const cardsList = response && response.data ? response.data : [];
      this.cardData = _.find(cardsList, {DefaultFlag: '1'});
      this.cardLoader = false;
    }, err => {
      this.invoiceData = [];
      this.cardLoader = false;
    });
  }

  getCurrentSubscription() {
    this.memberService.getCurrentSubscription(this.accessToken).subscribe((response: any) => {
      this.subscriptionData = response && response.data ? response.data : undefined;
      this.currentPlansData = this.subscriptionData && this.subscriptionData.plans && this.subscriptionData.plans[0] ? this.subscriptionData.plans : [];
      this.currentSubscription = _.find(this.currentPlansData, {type: 'subscription'});
      this.cameraSubscription = _.find(this.currentPlansData, {type: 'camera'});
      this.spaceHosted = _.find(this.currentPlansData, {type: 'space'});
      this.subscriptionLoader = false;
    }, err => {
      this.subscriptionLoader = false;
    });
  }

  seperateDateFormat(carddate) {
    const splitted = carddate.match(/(.{1,2})/g);
    return splitted[0] && splitted[1] ? splitted[1] + '/' + splitted[0] : '-';
  }

  addCameraSubscriptionEmit(response) {
    this.cameraSubscription = response;
    this.subscriptionLoader = true;
    this.resetSubscriptionValues();
    this.getCurrentSubscription();
    if (this.invoiceAccess) {
      this.invoiceLoader = true;
      this.getInvoices(1, this.itemsPerPage);
    }
  }

  removeCameraSubscriptionEmit(response) {
    this.cameraSubscription = undefined;
    if ($('#unsubscribeCamera')) {
      $('#unsubscribeCamera').modal('hide');
    }
    this.subscriptionLoader = true;
    this.resetSubscriptionValues();
    this.getCurrentSubscription();
  }

  resetSubscriptionValues() {
    this.subscriptionData = undefined;
    this.currentSubscription = undefined;
    this.currentPlansData = undefined;
    this.cameraSubscription = undefined;
    this.subscriptionChart = undefined;
  }

  downloadPdf(invoiceData) {
    // downloadInvoice
    if (this.invoiceDownload) {
      return;
    }
    this.selectedInvoice = invoiceData;
    this.invoiceDownload = true;
    this.invoiceDownloadError = undefined;

    this.paymentService.downloadPdf(invoiceData.uuid, this.accessToken).subscribe((resultBlob: Blob) => {
      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
        (window.navigator as any).msSaveOrOpenBlob(resultBlob);
        return;
      }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(resultBlob);
      const link = document.createElement('a');
      link.href = data;
      link.download = invoiceData.uuid + '.pdf';
      link.click();
      setTimeout(() => {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
      }, 100);
      this.invoiceDownload = false;
      this.selectedInvoice = undefined;
    }, err => {
      this.invoiceDownload = false;
      this.selectedInvoice = undefined;
      this.invoiceDownloadError = 'There was problem while downloading invoice';
    });

    // this.memberService.downloadInvoice(this.accessToken, invoiceData.uuid).subscribe(response => {
    //   debugger;
    //   // otherwise only Chrome works like it should
    //   const newBlob = new Blob([response.body], {type: 'application/pdf'});

    //   // IE doesn't allow using a blob object directly as link href
    //   // instead it is necessary to use msSaveOrOpenBlob
    //   if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    //     window.navigator.msSaveOrOpenBlob(newBlob);
    //     return;
    //   }

    //   // For other browsers:
    //   // Create a link pointing to the ObjectURL containing the blob.
    //   const data = window.URL.createObjectURL(newBlob);
    //   const link = document.createElement('a');
    //   link.href = data;
    //   link.download = invoiceData.uuid + '.pdf';
    //   link.click();
    //   setTimeout( () => {
    //     // For Firefox it is necessary to delay revoking the ObjectURL
    //     window.URL.revokeObjectURL(data);
    //   }, 100);
    //   // const buff = Buffer.from(response.data);
    //   // const blob = new Blob([buff], { type: 'application/pdf' });
    //   // const a = document.createElement('a');
    //   // if (window.navigator.msSaveOrOpenBlob) {
    //   //   window.navigator.msSaveBlob(
    //   //     blob,
    //   //     invoiceData.uuid + '.pdf'
    //   //   );
    //   // } else {
    //   //   const url = window.URL.createObjectURL(blob);
    //   //   a.href = url;
    //   //   a.download = invoiceData.uuid + '.pdf';
    //   //   document.body.appendChild(a);
    //   //   a.click();
    //   //   document.body.removeChild(a);
    //   //   window.URL.revokeObjectURL(url);
    //   // }
    //   this.invoiceDownload = false;
    //   this.selectedInvoice = undefined;
    // }, err => {
    //   this.invoiceDownload = false;
    //   this.selectedInvoice = undefined;
    //   this.invoiceDownloadError = 'There was problem while downloading invoice';
    // });
  }

  _base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
  }

  shopCamera() {
    this.shopCameraClicked = true;
  }

  closeCameraSubscriptionModalEmit() {
    setTimeout(() => {
      this.shopCameraClicked = false;
    }, 100);
  }

}
